import { useState } from "react"
import { useAuth0 } from "@auth0/auth0-react"

export const useUpdateApplicationStatus = () => {
  const [updateLoading, setUpdateLoading] = useState(false)
  const [updateError, setUpdateError] = useState(null)
  const { getAccessTokenSilently } = useAuth0()
  const apiUrl = process.env.REACT_APP_API_URL

  const updateApplicationStatus = async (applicationId, status) => {
    setUpdateLoading(true)
    setUpdateError(null)
    try {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_API_AUDIENCE,
        },
      })
      const response = await fetch(
        `${apiUrl}/api/JobApplications/updateStatus/${applicationId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ status }),
        },
      )

      if (!response.ok) {
        throw new Error("Failed to update application status")
      }

      return true
    } catch (error) {
      console.error("Error updating application status:", error)
      setUpdateError("Failed to update application status. Please try again.")
      return false
    } finally {
      setUpdateLoading(false)
    }
  }

  return { updateApplicationStatus, updateLoading, updateError }
}

